import script from "./Borrowings.vue?vue&type=script&setup=true&lang=js"
export * from "./Borrowings.vue?vue&type=script&setup=true&lang=js"

import "./Borrowings.vue?vue&type=style&index=0&id=ce3fb8ee&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce3fb8ee"]])

export default __exports__